<template>
    <div class="modal fade" id="ModalTrilha" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-trilha">
            <div class="modal-content border-0">
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                        data-bs-dismiss="modal"
                        type="button"
                        aria-label="Fechar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>

                <div v-if="trilhaInterna" class="trilha-layout" role="dialog" aria-modal="true" aria-labelledby="trilha-titulo">
                    <aside class="trilha-aside">
                        <div class="trilha-aside-topo">
                        <div class="trilha-capa">
                            <img v-if="trilhaInterna.urlFoto"
                                 :src="trilhaInterna.urlFoto"
                                 :alt="`Capa da trilha ${trilhaInterna.nmTreinamento}`" />
                            <div v-else class="trilha-capa-vazia" aria-hidden="true">
                                <svg width="32" height="32" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2" /><path d="m21 16-5-5-9 9" /></svg>
                            </div>
                        </div>

                        <div v-if="tags.length" class="trilha-tags">
                            <span v-for="(tag, i) in tags"
                                  :key="tag"
                                  class="trilha-tag"
                                  :class="{ 'trilha-tag--primaria': i === 0 }">{{ tag }}</span>
                        </div>

                        <dl class="trilha-info">
                            <div class="trilha-info-linha">
                                <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>
                                <dt>Autor</dt>
                                <dd>{{ trilhaInterna.nmAutor || 'Desconhecido' }}</dd>
                            </div>
                            <div class="trilha-info-linha">
                                <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                                <dt>Duração total</dt>
                                <dd>{{ formatarDuracao(totalMinutos) }}</dd>
                            </div>
                            <div class="trilha-info-linha">
                                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 9 5-9 5-9-5 9-5Z" /><path d="m3 13 9 5 9-5" /></svg>
                                <dt>Sessões</dt>
                                <dd>{{ sessoesVisiveis.length }} · {{ plural(totalAulas, 'aula', 'aulas') }}</dd>
                            </div>
                        </dl>

                        <div v-if="seguindo && totalAulas" class="trilha-progresso">
                            <div class="trilha-progresso-topo">
                                <span>Seu progresso</span>
                                <span class="trilha-muted">{{ aulasConcluidas }} de {{ plural(totalAulas, 'aula', 'aulas') }}</span>
                            </div>
                            <div class="trilha-barra"
                                 role="progressbar"
                                 :aria-valuenow="progresso"
                                 aria-valuemin="0"
                                 aria-valuemax="100">
                                <div class="trilha-barra-fill" :style="{ width: progresso + '%' }"></div>
                            </div>
                        </div>
                        </div>

                        <footer class="trilha-footer">
                            <button v-if="mostrarIrParaTrilha"
                                    type="button"
                                    class="trilha-btn trilha-btn--primario"
                                    @click="irParaTrilha">
                                {{ aulasConcluidas > 0 ? 'Continuar trilha' : 'Ir para a trilha' }}
                                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                            </button>
                            <button v-if="seguindo"
                                    type="button"
                                    class="trilha-btn trilha-btn--perigo"
                                    @click="alternarSeguirTrilha">
                                Deixar de seguir
                            </button>
                            <button v-else
                                    type="button"
                                    class="trilha-btn trilha-btn--seguir"
                                    @click="alternarSeguirTrilha">
                                Seguir trilha
                            </button>
                        </footer>
                    </aside>

                    <section class="trilha-main">
                        <div class="trilha-corpo">
                        <header class="trilha-header">
                            <div class="trilha-header-texto">
                                <div class="trilha-eyebrow">
                                    <span>TRILHA</span>
                                    <span v-if="seguindo" class="trilha-badge">
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
                                        Seguindo
                                    </span>
                                </div>
                                <h2 id="trilha-titulo" class="trilha-titulo">{{ trilhaInterna.nmTreinamento }}</h2>
                                <p v-if="trilhaInterna.dsTreinamento"
                                   class="trilha-descricao"
                                   :class="{ 'trilha-descricao--clamp': !descricaoExpandida }">{{ trilhaInterna.dsTreinamento }}</p>
                                <button v-if="exibeBotaoVerMais"
                                        type="button"
                                        class="trilha-ver-mais"
                                        @click="alternarDescricao">
                                    {{ descricaoExpandida ? 'Ver menos' : 'Ver mais' }}
                                </button>
                            </div>
                        </header>

                        <div class="trilha-secao-label">CONTEÚDO DA TRILHA</div>

                        <div class="trilha-sessoes">
                            <div v-if="carregandoSessoes" class="trilha-vazio">Carregando o conteúdo…</div>
                            <div v-else-if="!sessoesVisiveis.length" class="trilha-vazio">Nenhuma sessão disponível.</div>
                            <div v-for="(sessao, i) in sessoesVisiveis" :key="sessao.idSessao" class="trilha-sessao">
                                <button type="button"
                                        class="trilha-sessao-btn"
                                        :class="{ 'is-vazia': sessao.vazia }"
                                        :aria-expanded="sessaoAberta === i ? 'true' : 'false'"
                                        :disabled="sessao.vazia"
                                        @click="alternarSessao(i, sessao.vazia)">
                                    <span class="trilha-sessao-num">{{ sessao.numero }}</span>
                                    <span class="trilha-sessao-titulo">{{ sessao.nmSessao }}</span>
                                    <span class="trilha-sessao-meta">{{ metaSessao(sessao) }}</span>
                                    <svg v-if="!sessao.vazia"
                                         class="trilha-chevron"
                                         :class="{ 'is-aberto': sessaoAberta === i }"
                                         viewBox="0 0 24 24"
                                         aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
                                </button>

                                <ul v-if="sessaoAberta === i && !sessao.vazia" class="trilha-aulas">
                                    <li v-for="aula in sessao.aulas" :key="aula.idRecursoSessao" class="trilha-aula">
                                        <svg :class="{ 'is-concluida': aula.concluida }" viewBox="0 0 24 24" aria-hidden="true">
                                            <circle cx="12" cy="12" r="9" /><path d="m10 8 6 4-6 4V8Z" />
                                        </svg>
                                        <span class="trilha-aula-titulo">{{ aula.nmRecurso }}</span>
                                        <span class="trilha-muted">{{ formatarDuracao(aula.duracaoMin) }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { urlApi, avisoToast } from '@/config/global';

    export default {
        name: 'ModalTrilha',
        props: {
            trilhaSelecionada: Object,
            mostrarIrParaTrilha: { type: Boolean, default: true },
        },
        data() {
            return {
                sessoes: [],
                trilhaCliente: null,
                modalInstance: null,
                trilhaInterna: null,
                descricaoExpandida: false,
                sessaoAberta: -1,
                recursosConcluidos: {},
                carregandoSessoes: false,
            };
        },
        watch: {
            trilhaSelecionada: {
                immediate: true,
                handler(novaTrilha) {
                    if (novaTrilha?.idTreinamento) {
                        this.trilhaInterna = { ...novaTrilha };
                        this.sessoes = [];
                        this.trilhaCliente = null;
                        this.descricaoExpandida = false;
                        this.sessaoAberta = -1;
                        this.recursosConcluidos = {};
                        this.carregandoSessoes = true;

                        this.$nextTick(() => {
                            this.modalInstance?.show();
                        });

                        this.getSessoes(novaTrilha.idTreinamento);
                        this.getTrilhaCliente(novaTrilha.idTreinamento);
                        this.getProgresso();
                    }
                }
            }
        },

        computed: {
            exibeBotaoVerMais() {
                const texto = this.trilhaInterna?.dsTreinamento || '';
                return texto.length > 180;
            },
            seguindo() {
                return !!this.trilhaCliente;
            },
            tags() {
                const trilha = this.trilhaInterna;
                if (!trilha) return [];
                const nome = trilha.nmCategoria || trilha.categoria;
                return nome ? [nome] : [];
            },
            sessoesVisiveis() {
                return this.sessoes.map((sessao, i) => {
                    const recursos = sessao.recursos || [];
                    const aulas = recursos.map(recurso => ({
                        ...recurso,
                        duracaoMin: this.minutosDe(recurso.nrDuracao),
                        concluida: !!this.recursosConcluidos[Number(recurso.idRecursoSessao)],
                    }));
                    const segundos = recursos.reduce((total, recurso) => total + (Number(recurso.nrDuracao) || 0), 0);
                    return {
                        ...sessao,
                        aulas,
                        numero: String(i + 1).padStart(2, '0'),
                        vazia: aulas.length === 0,
                        minutos: this.minutosDe(segundos),
                    };
                });
            },
            totalAulas() {
                return this.sessoesVisiveis.reduce((total, sessao) => total + sessao.aulas.length, 0);
            },
            totalMinutos() {
                const segundos = this.sessoes.reduce((total, sessao) =>
                    total + (sessao.recursos || []).reduce((acc, recurso) => acc + (Number(recurso.nrDuracao) || 0), 0)
                , 0);
                return this.minutosDe(segundos);
            },
            aulasConcluidas() {
                return this.sessoesVisiveis.reduce(
                    (total, sessao) => total + sessao.aulas.filter(aula => aula.concluida).length,
                    0
                );
            },
            progresso() {
                if (!this.totalAulas) return 0;
                return Math.round((this.aulasConcluidas / this.totalAulas) * 100);
            },
        },

        beforeUnmount() {
            this.modalInstance?.dispose?.();
        },

        methods: {
            fechar() {
                this.modalInstance?.hide();
            },

            irParaTrilha() {
                if (this.trilhaInterna?.idTreinamento) {
                    this.$router.push({
                        path: '/SollAcademyAula',
                        query: { idTrilha: this.trilhaInterna.idTreinamento }
                    });
                    this.fechar();
                }
            },

            alternarDescricao() {
                this.descricaoExpandida = !this.descricaoExpandida;
            },

            alternarSessao(indice, vazia) {
                if (vazia) return;
                this.sessaoAberta = this.sessaoAberta === indice ? -1 : indice;
            },

            plural(quantidade, singular, pluralTxt) {
                return `${quantidade} ${quantidade === 1 ? singular : pluralTxt}`;
            },

            minutosDe(segundos) {
                const total = Number(segundos) || 0;
                if (total <= 0) return 0;
                return Math.max(1, Math.round(total / 60));
            },

            formatarDuracao(minutos) {
                if (!minutos) return '—';
                if (minutos < 60) return `${minutos} min`;
                const horas = Math.floor(minutos / 60);
                const resto = minutos % 60;
                return resto ? `${horas}h ${resto}min` : `${horas}h`;
            },

            metaSessao(sessao) {
                if (sessao.vazia) return 'Em breve';
                return `${this.plural(sessao.aulas.length, 'aula', 'aulas')} · ${this.formatarDuracao(sessao.minutos)}`;
            },

            getSessoes(idTreinamento) {
                this.carregandoSessoes = true;
                axios.get(`${urlApi}/SollAcademy/GetSessoes`, { params: { idTreinamento } })
                    .then(res => {
                        if (!res.data.success) {
                            this.carregandoSessoes = false;
                            return;
                        }
                        const sessoes = res.data.data.rows.map(r => r.item);
                        const promessas = sessoes.map(sessao =>
                            axios.get(`${urlApi}/SollAcademy/GetRecursosSessoes`, { params: { idSessao: sessao.idSessao } })
                                .then(resp => {
                                    sessao.recursos = resp.data.success
                                        ? resp.data.data.rows.map(r => r.item)
                                        : [];
                                }).catch(() => { sessao.recursos = []; })
                        );
                        Promise.all(promessas).then(() => {
                            this.sessoes = sessoes;
                            this.sessaoAberta = sessoes.findIndex(sessao => sessao.recursos && sessao.recursos.length);
                        }).finally(() => { this.carregandoSessoes = false; });
                    }).catch(() => {
                        this.carregandoSessoes = false;
                        avisoToast('Erro ao carregar seções.', 'danger');
                    });
            },

            getProgresso() {
                axios.get(`${urlApi}/SollAcademy/GetProgressosClientes`)
                    .then(res => {
                        if (!res.data.success) return;
                        const concluidos = {};
                        res.data.data.rows
                            .map(r => r.item)
                            .filter(item => item.flConcluido === true)
                            .forEach(item => {
                                concluidos[Number(item.idRecursoSessao)] = true;
                            });
                        this.recursosConcluidos = concluidos;
                    }).catch(() => { this.recursosConcluidos = {}; });
            },

            getTrilhaCliente(idTreinamento) {
                axios.get(`${urlApi}/SollAcademy/GetTreinamentosClientes`, { params: { idTreinamento } })
                    .then(res => {
                        this.trilhaCliente = (res.data.success && res.data.data.rows.length)
                            ? res.data.data.rows[0].item
                            : null;
                    }).catch(() => { this.trilhaCliente = null; });
            },

            alternarSeguirTrilha() {
                if (!this.trilhaInterna?.idTreinamento) return;
                if (this.trilhaCliente) {
                    axios.post(`${urlApi}/SollAcademy/DeleteTreinamentoCliente`, {
                        idTreinamentoCliente: this.trilhaCliente.idTreinamentoCliente
                    }).then(res => {
                        if (res.data.success) {
                            avisoToast('Você deixou de seguir essa trilha.', 'info');
                            this.trilhaCliente = null;
                            this.$emit('deixouDeSeguir');
                            this.fechar();
                        }
                    }).catch(() => avisoToast('Erro ao deixar de seguir trilha.', 'danger'));
                } else {
                    axios.post(`${urlApi}/SollAcademy/PostTreinamentoCliente`, {
                        DadosTreinamentoClienteCliente: {
                            idTreinamento: this.trilhaInterna.idTreinamento,
                            flConcluido: false
                        }
                    }).then(res => {
                        if (res.data.success) {
                            avisoToast('Você está seguindo essa trilha!', 'success');
                            this.getTrilhaCliente(this.trilhaInterna.idTreinamento);
                        }
                    }).catch(() => avisoToast('Erro ao seguir trilha.', 'danger'));
                }
            },
        },

        mounted() {
            const el = document.getElementById('ModalTrilha');
            this.modalInstance = new window.bootstrap.Modal(el);

            el.addEventListener('hidden.bs.modal', () => {
                this.$emit('fechar');
                this.trilhaInterna = null;
                this.sessoes = [];
                this.trilhaCliente = null;
                this.descricaoExpandida = false;
                this.sessaoAberta = -1;
                this.recursosConcluidos = {};
                this.carregandoSessoes = false;
            });
        },
    };
</script>

<style scoped>
    .modal-trilha {
        width: min(1280px, calc(100vw - 2.5rem));
        max-width: 1280px;
        margin: 1.25rem auto;
    }

    .modal-content {
        position: relative;
        overflow: visible;
        background: transparent;
        box-shadow: none;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        background: #ffffff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        z-index: 10;
    }

        .btn-close-modern:hover {
            transform: scale(1.07);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
            border-color: transparent !important;
        }

            .btn-close-modern:hover svg {
                color: #ffffff;
            }

    .trilha-layout {
        --trilha-primaria: #1463ff;
        --trilha-primaria-hover: #0b4fd6;
        --trilha-texto: #0f172a;
        --trilha-texto-2: #334155;
        --trilha-muted: #64748b;
        --trilha-borda: #e2e8f0;
        --trilha-borda-suave: #eef2f7;
        --trilha-superficie: #f8fafc;
        --trilha-perigo: #b91c1c;
        --trilha-fundo: #ffffff;

        width: 100%;
        height: min(920px, calc(100vh - 4.5rem));
        display: grid;
        grid-template-columns: 480px minmax(0, 1fr);
        background: var(--trilha-fundo);
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 24px 64px rgba(15, 23, 42, 0.28);
        color: var(--trilha-texto);
        font-family: 'Poppins', system-ui, sans-serif;
    }

    .trilha-layout svg {
        fill: none;
        stroke: currentColor;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .trilha-aside {
        display: flex;
        flex-direction: column;
        padding: 28px;
        background: var(--trilha-superficie);
        border-right: 1px solid var(--trilha-borda-suave);
        min-height: 0;
        overflow: hidden;
    }

    .trilha-aside-topo {
        display: flex;
        flex-direction: column;
        gap: 20px;
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
    }

    .trilha-capa {
        width: 100%;
        aspect-ratio: 990 / 520;
        flex: 0 0 auto;
        border-radius: 14px;
        overflow: hidden;
        background: #0b1220;
        box-shadow: 0 6px 20px rgba(15, 23, 42, 0.14);
    }

        .trilha-capa img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
        }

    .trilha-capa-vazia {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #94a3b8;
        background: #e2e8f0;
    }

    .trilha-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .trilha-tag {
        font-size: 12px;
        font-weight: 600;
        color: var(--trilha-texto-2);
        background: var(--trilha-fundo);
        border: 1px solid var(--trilha-borda);
        padding: 4px 12px;
        border-radius: 999px;
    }

    .trilha-tag--primaria {
        color: #1d4ed8;
        background: #eff4ff;
        border-color: #eff4ff;
    }

    .trilha-info {
        margin: 0;
        background: var(--trilha-fundo);
        border: 1px solid var(--trilha-borda-suave);
        border-radius: 12px;
    }

    .trilha-info-linha {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
        font-size: 13px;
    }

        .trilha-info-linha + .trilha-info-linha {
            border-top: 1px solid var(--trilha-borda-suave);
        }

        .trilha-info-linha svg {
            width: 16px;
            height: 16px;
            color: var(--trilha-muted);
            flex-shrink: 0;
        }

        .trilha-info-linha dt {
            flex-grow: 1;
            color: var(--trilha-muted);
            font-weight: 400;
        }

        .trilha-info-linha dd {
            margin: 0;
            font-weight: 600;
        }

    .trilha-progresso {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .trilha-progresso-topo {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        font-size: 13px;
        font-weight: 600;
    }

        .trilha-progresso-topo .trilha-muted {
            font-weight: 400;
        }

    .trilha-barra {
        height: 6px;
        background: var(--trilha-borda);
        border-radius: 999px;
        overflow: hidden;
    }

    .trilha-barra-fill {
        height: 100%;
        background: var(--trilha-primaria);
        border-radius: 999px;
        transition: width 0.3s ease;
    }

    .trilha-main {
        display: flex;
        flex-direction: column;
        min-height: 0;
        min-width: 0;
        background: var(--trilha-fundo);
    }

    .trilha-corpo {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
    }

    .trilha-header {
        padding: 32px 40px 0;
    }

    .trilha-header-texto {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding-right: 12px;
    }

    .trilha-eyebrow {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.1em;
        color: var(--trilha-muted);
    }

    .trilha-badge {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        letter-spacing: 0;
        color: #047857;
        background: #ecfdf5;
        padding: 3px 10px;
        border-radius: 999px;
    }

        .trilha-badge svg {
            width: 12px;
            height: 12px;
            stroke-width: 3;
        }

    .trilha-titulo {
        margin: 0;
        font-size: 26px;
        line-height: 1.25;
        font-weight: 700;
        color: var(--trilha-texto);
    }

    .trilha-descricao {
        margin: 0;
        font-size: 14px;
        line-height: 1.6;
        color: #475569;
    }

    .trilha-descricao--clamp {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        line-clamp: 3;
        overflow: hidden;
    }

    .trilha-ver-mais {
        align-self: flex-start;
        padding: 0;
        border: 0;
        background: none;
        color: var(--trilha-primaria);
        font: inherit;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
    }

        .trilha-ver-mais:hover {
            text-decoration: underline;
        }

    .trilha-secao-label {
        padding: 24px 40px 0;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.1em;
        color: var(--trilha-muted);
    }

    .trilha-sessoes {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 12px 40px 20px;
    }

    .trilha-vazio {
        font-size: 13px;
        color: var(--trilha-muted);
        padding: 8px 0;
    }

    .trilha-sessao {
        border: 1px solid var(--trilha-borda);
        border-radius: 12px;
        background: var(--trilha-fundo);
    }

    .trilha-sessao-btn {
        width: 100%;
        min-height: 56px;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 12px 16px;
        border: 0;
        background: none;
        font: inherit;
        text-align: left;
        cursor: pointer;
        border-radius: 12px;
        color: inherit;
    }

        .trilha-sessao-btn:hover:not(:disabled) {
            background: var(--trilha-superficie);
        }

        .trilha-sessao-btn:disabled {
            cursor: default;
        }

    .trilha-sessao-num {
        width: 30px;
        height: 30px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        background: #eff4ff;
        color: #1d4ed8;
        font-size: 12px;
        font-weight: 700;
    }

    .trilha-sessao-titulo {
        flex-grow: 1;
        font-size: 14px;
        font-weight: 600;
        color: var(--trilha-texto);
    }

    .trilha-sessao-meta {
        font-size: 12px;
        color: var(--trilha-muted);
        white-space: nowrap;
    }

    .is-vazia .trilha-sessao-titulo {
        color: var(--trilha-muted);
    }

    .is-vazia .trilha-sessao-num {
        background: #f1f5f9;
        color: #94a3b8;
    }

    .trilha-chevron {
        width: 18px;
        height: 18px;
        color: var(--trilha-muted);
        flex-shrink: 0;
        transition: transform 0.2s;
    }

        .trilha-chevron.is-aberto {
            transform: rotate(180deg);
        }

    .trilha-aulas {
        list-style: none;
        margin: 0;
        padding: 6px 16px 10px 60px;
        border-top: 1px solid var(--trilha-borda-suave);
    }

    .trilha-aula {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 8px 0;
        font-size: 13px;
        color: var(--trilha-texto-2);
    }

        .trilha-aula svg {
            width: 16px;
            height: 16px;
            color: #94a3b8;
            flex-shrink: 0;
        }

            .trilha-aula svg.is-concluida {
                color: #059669;
            }

    .trilha-aula-titulo {
        flex-grow: 1;
    }

    .trilha-footer {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
        flex-shrink: 0;
        margin-top: 20px;
        padding-top: 16px;
        border-top: 1px solid var(--trilha-borda-suave);
    }

    .trilha-btn {
        min-height: 44px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 0 20px;
        border: 0;
        border-radius: 10px;
        font: inherit;
        font-size: 14px;
        cursor: pointer;
        transition: background 0.15s;
    }

        .trilha-btn svg {
            width: 16px;
            height: 16px;
            stroke-width: 2.2;
        }

    .trilha-btn--primario {
        background: var(--trilha-primaria);
        color: #fff;
        font-weight: 600;
        justify-content: center;
    }

        .trilha-btn--primario:hover {
            background: var(--trilha-primaria-hover);
        }

    .trilha-btn--perigo,
    .trilha-btn--seguir {
        background: none;
        font-weight: 500;
        justify-content: center;
    }

    .trilha-btn--perigo {
        color: var(--trilha-perigo);
    }

        .trilha-btn--perigo:hover {
            background: #fef2f2;
        }

    .trilha-btn--seguir {
        color: var(--trilha-primaria);
    }

        .trilha-btn--seguir:hover {
            background: #eff4ff;
        }

    .trilha-muted {
        color: var(--trilha-muted);
        white-space: nowrap;
    }

    .trilha-layout button:focus-visible {
        outline: 2px solid var(--trilha-primaria);
        outline-offset: 2px;
    }

    @media (max-width: 820px) {
        .modal-trilha {
            width: calc(100% - 1rem);
            margin: 0.5rem auto;
        }

        .trilha-layout {
            height: auto;
            max-height: calc(100vh - 2rem);
            display: flex;
            flex-direction: column;
            overflow-y: auto;
        }

        .trilha-aside {
            border-right: 0;
            padding: 16px 20px 0;
            overflow: visible;
            background: var(--trilha-fundo);
        }

        .trilha-aside-topo {
            overflow: visible;
            flex: none;
        }

        .trilha-main {
            min-height: auto;
        }

        .trilha-corpo {
            overflow: visible;
            min-height: auto;
        }

        .trilha-header,
        .trilha-secao-label {
            padding-left: 20px;
            padding-right: 20px;
        }

        .trilha-header {
            padding-top: 16px;
        }

        .trilha-titulo {
            font-size: 22px;
        }

        .trilha-sessoes {
            overflow: visible;
            padding: 12px 20px 16px;
        }

        .trilha-footer {
            margin-top: 16px;
            padding: 16px 0 8px;
        }

        .trilha-sessao-btn {
            flex-wrap: wrap;
        }

        .trilha-sessao-meta {
            margin-left: 44px;
        }
    }

    [data-bs-theme="dark"] #ModalTrilha .btn-close-modern {
        background: rgba(15, 23, 42, 0.95) !important;
        border-color: rgba(148, 163, 184, 0.3) !important;
    }

        [data-bs-theme="dark"] #ModalTrilha .btn-close-modern svg {
            color: #e2e8f0;
        }

        [data-bs-theme="dark"] #ModalTrilha .btn-close-modern:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        }

            [data-bs-theme="dark"] #ModalTrilha .btn-close-modern:hover svg {
                color: #ffffff;
            }

    [data-bs-theme="dark"] #ModalTrilha .trilha-layout {
        --trilha-primaria: #3b82f6;
        --trilha-primaria-hover: #2563eb;
        --trilha-texto: #f1f5f9;
        --trilha-texto-2: #cbd5e1;
        --trilha-muted: #94a3b8;
        --trilha-borda: rgba(148, 163, 184, 0.22);
        --trilha-borda-suave: rgba(148, 163, 184, 0.14);
        --trilha-superficie: #0f172a;
        --trilha-perigo: #fca5a5;
        --trilha-fundo: #1e293b;
        box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);
    }

    [data-bs-theme="dark"] #ModalTrilha .trilha-capa-vazia {
        background: #0f172a;
        color: #64748b;
    }

    [data-bs-theme="dark"] #ModalTrilha .trilha-tag--primaria {
        color: #93c5fd;
        background: rgba(59, 130, 246, 0.16);
        border-color: transparent;
    }

    [data-bs-theme="dark"] #ModalTrilha .trilha-sessao-num {
        background: rgba(59, 130, 246, 0.16);
        color: #93c5fd;
    }

    [data-bs-theme="dark"] #ModalTrilha .is-vazia .trilha-sessao-num {
        background: rgba(148, 163, 184, 0.12);
        color: #64748b;
    }

    [data-bs-theme="dark"] #ModalTrilha .trilha-descricao {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] #ModalTrilha .trilha-badge {
        color: #6ee7b7;
        background: rgba(16, 185, 129, 0.16);
    }

    [data-bs-theme="dark"] #ModalTrilha .trilha-btn--perigo:hover {
        background: rgba(248, 113, 113, 0.12);
    }

    [data-bs-theme="dark"] #ModalTrilha .trilha-btn--seguir:hover {
        background: rgba(59, 130, 246, 0.16);
    }

    [data-bs-theme="dark"] #ModalTrilha .trilha-aula svg.is-concluida {
        color: #34d399;
    }
</style>
